import { ApiService } from 'react-angle-dashboard-components'

export class EmailService extends ApiService {
  async sendLoginEmail(email: string) {
    return this.request({
      method: 'post',
      url: '/email/login',
      data: { email }
    })
  }

  async sendOnboardingEmail() {
    return this.request({
      method: 'post',
      url: '/email/group-onboarding'
    })
  }
}
